import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Pencil, Trash2, GripVertical } from 'lucide-react';
import Participant from './Participant';
import FadingArrow, { GetFrontalClass } from './FadingArrow';
import { formatTime } from '../utils';

const SortableItem = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: props.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '0.5em',
    margin: '0.3em 0',
    width: ' 60em',
    marginLeft: 'auto',
    marginRight: 'auto',
    userSelect: 'none',
    height: '50px',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  const visible = props.participant.visible;
  const trClass = props.className + " pilot-list-row "
    + ((!props.editMode && props.selected === props.participant.id) ? "order-selected" : "");
  const tdVisibility = (visible || props.editMode || props.showAllParticipants) ? 'visible' : 'hidden';
  const tdClass = props.fadingIn ? 'fade-in' : '';
  const onFadeEnd = props.fadingIn ? () => props.onFadeEnd(props.id) : undefined;

  return (
    <tr ref={setNodeRef} data-id={props.id}
      className={trClass}
      style={style}
      {...attributes} {...listeners}>
      <td className={'text-center ' + tdClass} onAnimationEnd={onFadeEnd} style={{ width: '2em', verticalAlign: 'middle', visibility: tdVisibility }}>
        {(!props.editMode && props.selected === props.participant.id) ? <FadingArrow direction='right' /> : null}
      </td>
      <td className={'text-center ' + tdClass} style={{ verticalAlign: 'middle', visibility: tdVisibility }}>
        <span className={"style-frontal" + GetFrontalClass(props.participant.completed, props.participant.choose)}>{props.participant.ident}</span>
      </td>
      <td className={tdClass} style={{ verticalAlign: 'middle', visibility: tdVisibility }}>
        {props.participant.brandLogo && <img style={{ height: '32px' }} src={props.participant.brandLogo} title={props.participant.vehicle} alt={props.participant.vehicle}></img>}
      </td>
      <td className={'participant ' + tdClass} style={{ verticalAlign: 'middle', visibility: tdVisibility, fontSize: '0.85em' }}>
        {props.showTeam ? (props.participant.competitor || '') : null}
      </td>
      <Participant title={props.participant.pilot} flagUrl={props.participant.pilotFlag} visible={visible || props.editMode || props.showAllParticipants} tdClass={tdClass} />
      {props.showCodriver && <Participant title={props.participant.copilot} flagUrl={props.participant.copilotFlag} visible={visible || props.editMode || props.showAllParticipants} tdClass={tdClass} />}
      {props.showTime && (
        <td className={'participant ' + tdClass} style={{ verticalAlign: 'middle', visibility: tdVisibility }}>
          <div className='style-time'>{formatTime(props.participant.total)}</div>
        </td>
      )}
      <td className={'text-center ' + tdClass} style={{ width: '5em', verticalAlign: 'middle', visibility: tdVisibility }}>
        {props.editMode
          ? <span style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
              <span onClick={() => props.onDelete(props.id)} style={{ cursor: 'pointer' }}><Trash2 size={16} color='#cc4444' /></span>
              <span onClick={() => props.onEdit(props.id)} style={{ cursor: 'pointer' }}><Pencil size={16} color='#4488cc' /></span>
              <GripVertical size={16} color='#aaaaaa' style={{ cursor: 'grab', flexShrink: 0 }} />
            </span>
          : props.draggable
            ? <GripVertical size={16} color='#aaaaaa' style={{ cursor: 'grab' }} />
            : (props.selected === props.participant.id) ? <FadingArrow direction='left' /> : null
        }
      </td>
    </tr>
  );
};

export default SortableItem;